import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NationalTeamShortModal } from "app/components";
import { DrawWCGroupLooserModal } from "app/components/modals/draw-wc-group-looser-modal";
import { DrawingWCFinalDataDto, WCGroupLooserDataDto, WCGroupWinnerDataDto, DrawingWCFinalDto, TeamShortDto, DrawingWCFinalResponseDto } from "app/models";
import { DrawingsService, NationalTeamService, NotificationService } from "app/services";

@Component({
    selector: 'wc-final',
    templateUrl: 'wc-final.page.html',
    styleUrls: ['wc-final.page.scss'],
})
export class WCFinalPage implements OnInit {
    data: DrawingWCFinalDataDto;

    allNationalGroups: string[];
    allU21Groups: string[];

    nationalSquadsTotalCount: number = 0;
    u21SquadsTotalCount: number = 0;

    baskets: DrawingWCFinalDto;

    formGroup: FormGroup;

    drawingResult: DrawingWCFinalResponseDto;

    nationalRatings: number[] = [];
    
    constructor(private drawingService: DrawingsService, 
        private modalService: NgbModal,
        private notificationService: NotificationService,
        private nationalTeamService: NationalTeamService) { }
    
    ngOnInit(): void {
        this.loadRatings();
        this.loadData();
        this.buildFormGroup();
    }

    public removeNationalLooser(line: number, group: string) {
        this.removeLooser(this.data.nat.loosers, line, group);

        this.calculateNationalSquadsTotalCount();
    }

    public removeU21Looser(line: number, group: string) {
        this.removeLooser(this.data.u21.loosers, line, group);
        this.calculateU21lSquadsTotalCount();
    }

    public removeNationalWinner(line: number, group: string) {
        this.removeWinner(this.data.nat.groups, line, group);

        this.calculateNationalSquadsTotalCount();
    }

    public removeU21Winner(line: number, group: string) {
        this.removeWinner(this.data.u21.groups, line, group);
        this.calculateU21lSquadsTotalCount();
    }

    public addNationalWinner(groupName: string) {
        this.addWinner(this.data.nat.groups, groupName);
    }

    public addU21Winner(groupName: string) {
        this.addWinner(this.data.u21.groups, groupName);
        this.calculateU21lSquadsTotalCount();
    }

    public addNationalLooser() {
        const modalRef = this.modalService.open(DrawWCGroupLooserModal);

            modalRef.componentInstance.groups= this.allNationalGroups;

            modalRef.result.then((result) => {
                if (result) {
                    this.addLooser(this.data.nat.loosers, result);
                }
            }, (reason) => { });
    }

    public addU21Looser() {
        const modalRef = this.modalService.open(DrawWCGroupLooserModal);

            modalRef.componentInstance.groups= this.allU21Groups;

            modalRef.result.then((result) => {
                if (result) {
                    this.addLooser(this.data.u21.loosers, result);
                    this.calculateU21lSquadsTotalCount();
                }
            }, (reason) => { });
    }

    public getBaskets() {
        this.drawingService.getWCFinalBaskets(this.data)
            .subscribe(result => {
                this.baskets = result;
            }, error => {

            })
    }

    onChangeNationalTeam(basketNumber: number, index: number, team: TeamShortDto) {
        let basket: TeamShortDto[];
        
        switch(basketNumber) {
            case 1: basket = this.baskets.nat.basket1;
            break;
            case 2: basket = this.baskets.nat.basket2;
            break;
            case 3: basket = this.baskets.nat.basket3;
            break;
            case 4: basket = this.baskets.nat.basket4;
            break;
        }
        
        const modalRef = this.modalService.open(NationalTeamShortModal);

        modalRef.componentInstance.team = team;

        modalRef.result.then((result) => {
            if (result) {
                basket[index] = result;
            }
        }, (reason) => { });
    }

    onChangeU21Team(basketNumber: number, index: number, team: TeamShortDto) {
        let basket: TeamShortDto[];
        
        switch(basketNumber) {
            case 1: basket = this.baskets.u21.basket1;
            break;
            case 2: basket = this.baskets.u21.basket2;
            break;
            case 3: basket = this.baskets.u21.basket3;
            break;
            case 4: basket = this.baskets.u21.basket4;
            break;
        }
        
        const modalRef = this.modalService.open(NationalTeamShortModal);

        modalRef.componentInstance.team = team;

        modalRef.result.then((result) => {
            if (result) {
                basket[index] = result;
            }
        }, (reason) => { });
    }

    doDraw() {
        if (!this.formGroup.controls.md1FormControl.value || !this.formGroup.controls.md2FormControl.value || !this.formGroup.controls.md3FormControl.value) {
            this.notificationService.showError('На заполенены ИД');
            
            return;
        }

        let mds: number[] = [this.formGroup.controls.md1FormControl.value, this.formGroup.controls.md2FormControl.value, this.formGroup.controls.md3FormControl.value] 

        this.drawingService.drawFCFinal(this.baskets.nat, this.baskets.u21, mds)
            .subscribe(result => {
                this.drawingResult = result;
            }, error => {
                this.notificationService.showError('Ошибка жеребьевки');
            })
    }

    getNationalTeamRating(teamId: number): number {
        if (!this.nationalRatings)
            return 0;

        return this.nationalRatings[teamId];
    }

    private loadRatings() {
        this.nationalTeamService.getGroupRatings()
            .subscribe(result => {
                this.nationalRatings = [];
                result.forEach(item => {
                    this.nationalRatings[item.teamId] = item.rating;
                })
            }, error => {
                this.notificationService.showError('Не удалось загрузить рейтинги');
            })
    }

    private removeLooser(array: WCGroupLooserDataDto[], line: number, group: string) {
        let dto = array.find(a => a.line == line);

        if (dto) {
            let gr = dto.groups.findIndex(g => g == group);
            
            if (gr >=0) {
                dto.groups.splice(gr, 1);

            }
        }
    }

    private removeWinner(array: WCGroupWinnerDataDto[], line: number, group: string) {
        let dto = array.find(a => a.group == group);

        if (dto) {
            let gr = dto.winners.indexOf(line);
            
            if (gr >=0) {
                dto.winners.splice(gr, 1);

                for (let i = 0; i< dto.winners.length; i++) {
                    dto.winners[i] = i+1;
                }
            }
        }
    }

    private loadData() {
        this.drawingService.getWCFinalData()
            .subscribe(result => {
                this.data = result;

                this.allNationalGroups = [];
                this.allU21Groups = [];

                this.data.nat.groups.forEach (item => {
                    this.allNationalGroups.push(item.group);
                });

                this.data.u21.groups.forEach (item => {
                    this.allU21Groups.push(item.group);
                })

                if (!this.data.nat.loosers) {
                    this.data.nat.loosers = [];
                }

                if (!this.data.u21.loosers) {
                    this.data.u21.loosers = [];
                }

                this.calculateNationalSquadsTotalCount();
                this.calculateU21lSquadsTotalCount();
            });
    }

    private calculateNationalSquadsTotalCount() {
        this.nationalSquadsTotalCount = 0;

        this.data.nat.groups.forEach(item => {
            this.nationalSquadsTotalCount += item.winners.length;
        })

        this.data.nat.loosers.forEach(item => {
            if (item.groups && item.groups.length > 0)
                this.nationalSquadsTotalCount += item.count;
        })
    }

    private calculateU21lSquadsTotalCount() {
        this.u21SquadsTotalCount = 0;

        this.data.u21.groups.forEach(item => {
            this.u21SquadsTotalCount += item.winners.length;
        })

        this.data.u21.loosers.forEach(item => {
            if (item.groups && item.groups.length > 0)
                this.u21SquadsTotalCount += item.count;
        })
    }

    private addWinner(groups: WCGroupWinnerDataDto[], groupName: string) {
        let group = groups.find(g => g.group == groupName);

        if (group) {
            let count = group.winners.length;

            if (!group.winners) {
                group.winners = [];
            }

            group.winners.push(count + 1);
        }
    }

    private addLooser(data: WCGroupLooserDataDto[], item: WCGroupLooserDataDto) {
        let looserData = data.find(f => f.line == item.line);

        if (looserData) {
            looserData.groups = item.groups;
        } else {
            data.push(item);
        }
    }

    private buildFormGroup() {
        this.formGroup = new FormGroup({
            md1FormControl: new FormControl(),
            md2FormControl: new FormControl(),
            md3FormControl: new FormControl(),
        })
    }
}